export default __webpack_public_path__ + "static/media/loginLogoIcon.34b51808.71c456dc.png";